import React from 'react';
import PropTypes from 'prop-types';
import EpisodeSelection from '../../EpisodeSelection';
import Translator from '../../../requests/apa/Translator';
import { cls } from '../../../packages/components';

var NOOP = function() {};

class VCardEpisodes extends React.PureComponent{

  render() {
        const {serieData, handleEpisodeClick, setMetricsEvent, handlePlay, getPlayButton, title, onHandleFocusEpisodes, lastTouchSeen } = this.props;
        if(serieData && serieData.seasons && serieData.seasons.length > 0){
            const {
                seasonNumber = "",
                seasons = []
            } = serieData || {};
            const currentSeason = seasons.find(seanson=>seanson.number === seasonNumber);
            const {
                episodes_count = 0
            } = currentSeason || {}
            return (
                <div ref='VCardEpisodes' className={cls("vcard-episodes")}>
                    <div className="vcard-episodes-label">
                        <span className="bold">{`${Translator.get("vcard_access_abbreviationSeason_label", "Temporada")} ${seasonNumber}`}</span>
                        <span className="opacity">{`${episodes_count} ${Translator.get("vcard_access_abbreviationEpisode_label", "episodio")}${parseInt(episodes_count)>1?'s':''}`}</span>
                    </div>
                    <EpisodeSelection
                        disableSelectSeason
                        data={serieData}
                        handleEpisodeClick={handleEpisodeClick}
                        setMetricsEvent={setMetricsEvent}
                        dataMetric={title}
                        onHandleFocusEpisodes={onHandleFocusEpisodes}
                        lastTouchSeen={lastTouchSeen}
                    />
                </div>
            )
        }
        else{
            return null;
        }
    }
}

VCardEpisodes.propTypes = {
    serieData: PropTypes.object.isRequired,
    handleEpisodeClick: PropTypes.func.isRequired,
    setMetricsEvent: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
}

VCardEpisodes.defaultProps = {
    serieData: {},
    handleEpisodeClick: NOOP,
    setMetricsEvent: NOOP,
    handlePlay: NOOP,
    getPlayButton: NOOP,
    title: ''
}

export default VCardEpisodes;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardEpisodes.jsx